import { ActionTypes } from "../../enums";

export interface TransportServiceRequest {
    planId?: string;
    jobNumber?: string;
    action?: ActionTypes;
    locationId?: string;
    LC_Code?: string;
    product?: number;
    tripInfo?: string;
    description?: string;
    sequenceNumber:number;
  }
  